import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const MapplsServices = Object.freeze({
  search: "search",
  internal: "internal",
  place: "place",
  sdk: "sdk",
  route: "route",
});



const MapplsServicesEndpoints = Object.freeze({
  [MapplsServices.search]: "https://search.mappls.com",
  [MapplsServices.sdk]: "https://sdk.mappls.com",
  [MapplsServices.route]: "https://route.mappls.com",
  [MapplsServices.place]: "https://place.mappls.com",
  [MapplsServices.internal]: "/",
});


const InternalEndpoints = Object.freeze({
  addressAnalytics: "/api/mappls/addressAnalytics",
  reverseGeocode: "/api/mappls/rev-geocode",
});





const access_token = process.env.NEXT_PUBLIC_MAPPLS_REST_API_KEY;

const dynamicBaseQuery = async (args, api, extraOptions) => {
  const { serviceType } = args; // we pass this manually from endpoint

  if(!MapplsServicesEndpoints[serviceType]) {
    throw new Error("Invalid mappls service type");
  }
  const selectedBaseQuery = fetchBaseQuery({
    baseUrl: MapplsServicesEndpoints[serviceType],
  });

  return selectedBaseQuery(args, api, extraOptions);
};

 const mapplsApi = createApi({
  reducerPath: "mapplsApi",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getAutoSuggestionMappls: builder.query({
      query: (query) => ({
        url: `/search/places/autosuggest/json`,
        params: { query, access_token},
      }),
    }),
    getAddressAnalyticsMappls: builder.query({
      query: (address) => ({
        serviceType: MapplsServices.internal,
        url: InternalEndpoints.addressAnalytics,
        params: { address },
      }),
    }),
    getReverseGeocodeMappls: builder.query({
      query: ({lat, lng}) => ({
        serviceType: MapplsServices.search,
        url: `/search/address/rev-geocode`,
        params: { lat,lng, access_token},
      }),
    }),
    // getReverseGeocodeMappls: builder.query({
    //   query: ({lat, lng}) => ({
    //     serviceType: MapplsServices.internal,
    //     url: InternalEndpoints.reverseGeocode,
    //     params: { lat,lng },
    //   }),
    // }),
    getCoordinatesMappls: builder.query({
      query: (eloc) => ({
        serviceType: MapplsServices.place,
        url: `/O2O/entity/place-details/${eloc}`,
        params: { access_token },
      }),
    }),
  }),
});


export const {
  useGetAutoSuggestionMapplsQuery,
  useLazyGetCoordinatesMapplsQuery,
  useGetReverseGeocodeMapplsQuery,
  useLazyGetReverseGeocodeMapplsQuery,
  useLazyGetAddressAnalyticsMapplsQuery,
} = mapplsApi;
export { mapplsApi };
